const ks = `<p>“小”三粒骰子之点数总和由4点至10点；“大”三粒骰子之点数总和由11点至17点；若三粒骰子平面点数相同，则为通吃，通吃「大」、「小」各注。</p>

<p>“单”三粒骰子之点数总和为单数；“双”三粒骰子之点数总和为双数；若三粒骰子平面点数相同，则为通吃，通吃「单」、「双」各注。</p>`
const choose5 = `<p>总和路珠指5个开出的号码的总和对应的大小、单双，其中大于30为大，小于30为小,等于30为和。</p>`
export default {
  ks, choose5
}


// WEBPACK FOOTER //
// ./src/pages/Trend/Zongheluzhu/helpers/tips.js